import AppParallax from '../app-parallax'

export default
{
    components: {
        AppParallax
    }
}